/* @flow */
import cx from 'classnames';
import * as React from 'react';
import {
  Accordion as ReactAccessibleAccordion,
  AccordionItem as ReactAccessibleAccordionItem,
  AccordionItemBody as ReactAccessibleAccordionItemBody,
  AccordionItemTitle as ReactAccessibleAccordionItemTitle,
} from 'react-accessible-accordion';

import './Accordion.scss';

type Props = {
  className?: string,
  // from react-accessible-accordion
  accordion?: boolean,
};

function Accordion({ accordion, className, ...others }: Props) {
  return (
    <ReactAccessibleAccordion
      {...others}
      accordion={accordion}
      className={cx('Accordion', className)}
    />
  );
}

Accordion.defaultProps = {
  accordion: false,
};

type AccordionItemProps = {
  className?: string,
  disabled?: boolean,
};

function AccordionItem({ className, disabled, ...others }: AccordionItemProps) {
  return (
    <ReactAccessibleAccordionItem
      {...others}
      className={cx('AccordionItem', disabled && 'AccordionItem--disabled', className)}
      hideBodyClassName="AccordionItem--hidden"
    />
  );
}

type AccordionItemBodyProps = {
  className?: string,
};

function AccordionItemBody({ className, ...others }: AccordionItemBodyProps) {
  return (
    <ReactAccessibleAccordionItemBody
      {...others}
      className={cx('AccordionItemBody', className)}
      hideBodyClassName="AccordionItemBody--hidden"
    />
  );
}

type AccordionItemTitleProps = {
  className?: string,
};

function AccordionItemTitle({ className, ...others }: AccordionItemTitleProps) {
  return (
    <ReactAccessibleAccordionItemTitle
      {...others}
      className={cx('AccordionItemTitle', className)}
      hideBodyClassName="AccordionItemTitle--hidden"
    />
  );
}

export { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle };
